import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { collection, query, where, onSnapshot, orderBy } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
import { IoArrowBack, IoCarSportOutline, IoCarOutline, IoBusOutline, IoTimeOutline, IoCheckmarkCircleOutline, IoPencil, IoAddCircleOutline } from 'react-icons/io5';
import { FaMotorcycle } from 'react-icons/fa';
import './VehiculosScreen.css'; // --- Importamos estilos premium ---
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBottomNav from '../components/Shared/KondoBottomNav';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';

// Función iconografía inteligente (Misma que Admin)
const getVehiculoIcon = (vehiculo) => {
  const tipo = (vehiculo.tipo || '').toLowerCase();

  if (tipo === 'moto') return <FaMotorcycle size={22} />;
  if (tipo === 'suv') return <IoCarOutline size={22} />;
  if (tipo === 'camion') return <IoBusOutline size={22} />;

  return <IoCarSportOutline size={22} />;
};

function VehiculosScreen() {
  const navigate = useNavigate();
  const { currentUser, userData } = useAuth();
  const [vehiculos, setVehiculos] = useState([]);
  const [loading, setLoading] = useState(true);

  const targetUid = userData?.isSimulated ? (userData?.uid || userData?.id) : (currentUser?.uid || userData?.uid || userData?.id);

  useEffect(() => {
    if (!targetUid) {
      setLoading(false);
      return;
    }
    const q = query(
      collection(db, "vehiculos"),
      where("residenteId", "==", targetUid)
    );
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const listaVehiculos = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      // Ordenamiento en memoria seguro y veloz (evita errores de índices compuestos en Firestore)
      listaVehiculos.sort((a, b) => {
        if (a.estatus !== b.estatus) return (a.estatus || '').localeCompare(b.estatus || '');
        const fechaA = a.fechaRegistro?.seconds || 0;
        const fechaB = b.fechaRegistro?.seconds || 0;
        return fechaB - fechaA;
      });
      setVehiculos(listaVehiculos);
      setLoading(false);
    }, (error) => {
      console.error("Error al cargar vehículos: ", error);
      setLoading(false);
    });
    return () => unsubscribe();
  }, [targetUid]);

  return (
    <div className="ks-page">
      <KondoSidebar activeRoute="/vehiculos" />
      <main className="ks-main">
      <div className="ks-header-sticky-wrapper">
        <KondoBrandHeader showBack={false} />
      </div>
      <div className="ks-scroll-area">
        <div className="muro-header-stitch">
          <div className="muro-hero-card">
            <div className="muro-hero-content">
              <h1>Mis Vehículos</h1>
              <p>Administración de autos</p>
              <button className="muro-hero-action-btn" onClick={() => navigate('/vehiculos/nuevo')}>
                <IoAddCircleOutline size={20} />
                <span>Nuevo</span>
              </button>
            </div>
            <IoCarSportOutline className="muro-hero-icon-decor" />
          </div>
        </div>
        <div className="vehiculos-dashboard-container">

      {loading && (
        <div className="empty-state">
          <p>Cargando tus vehículos...</p>
        </div>
      )}

      {!loading && vehiculos.length === 0 && (
        <div className="empty-state">
          <IoCarSportOutline size={48} style={{ opacity: 0.3, marginBottom: 10 }} />
          <p>No tienes vehículos registrados aún.</p>
        </div>
      )}

      {!loading && vehiculos.length > 0 && (
        <div className="vehiculos-list">
          {vehiculos.map(vehiculo => {
            const esActivo = vehiculo.estatus === 'activo';
            return (
              <div key={vehiculo.id} className="vehiculo-card-item">
                <div className="vehiculo-icon-frame">
                  {getVehiculoIcon(vehiculo)}
                </div>

                <div className="vehiculo-info">
                  <div className="vehiculo-header-row">
                    <span className="modelo-text">{vehiculo.marca} {vehiculo.modelo}</span>
                    <span className="placas-text">{vehiculo.placas || 'S/P'}</span>
                  </div>
                  <div className="vehiculo-details">
                    <span>{vehiculo.anio} • {vehiculo.color}</span>
                  </div>
                  <div style={{ marginTop: 4 }}>
                    <span className={`status-pill ${esActivo ? 'active' : 'pending'}`} style={{ padding: '2px 8px', fontSize: '0.75rem' }}>
                      {esActivo ? (
                        <><IoCheckmarkCircleOutline style={{ marginRight: 4 }} /> Activo</>
                      ) : (
                        <><IoTimeOutline style={{ marginRight: 4 }} /> Pendiente</>
                      )}
                    </span>
                  </div>
                </div>

                {vehiculo.estatus !== 'activo' && (
                  <button
                    className="btn-icon btn-edit"
                    title="Editar"
                    onClick={() => navigate(`/vehiculos/editar/${vehiculo.id}`)}
                  >
                    <IoPencil size={18} />
                  </button>
                )}
                {esActivo && <div style={{ width: 38 }} />} {/* Spacer if no button */}
              </div>
            );
          })}
        </div>
      )}
          </div>
        </div>
        {/* ── FLOATING ISLAND BOTTOM NAV (mobile) ── */}
        <KondoBottomNav activeRoute="/vehiculos" />
      </main>
    </div>
  );
}

export default VehiculosScreen;